import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Button, Typography } from '@mui/material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useCallbacks } from 'shared/hooks/utils';
import { getAutoPaymentTranslate } from 'console/billing/types';
import { disable_auto_payment } from 'console/billing/redux/actions';
import { useAction } from 'shared/hooks/redux/hooks';
export const OffAutoPaymentDialog = memo(function OffAutoPaymentDialog(props) {
    const { open, onClose, auto_payment } = props;
    const onDisableAutoPayments = useCallbacks([
        useAction(disable_auto_payment),
        onClose,
    ]);
    return (_jsxs(MessageBox, { open: open, onClose: onClose, isError: true, footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: onClose, children: "\u041D\u0435\u0442" }), _jsx(Button, { onClick: onDisableAutoPayments, children: "\u0414\u0430" })] }), children: [auto_payment && (_jsx(Typography, { variant: "subtitle1", children: getAutoPaymentTranslate(auto_payment) })), _jsx(Typography, { variant: "subtitle1", children: "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043F\u043B\u0430\u0442\u0451\u0436?" })] }));
});
